/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, message, Input, Modal } from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import "./processedRequests.scss";
import { ReactComponent as View_icon } from "../../../assests/images/SVG/view-details.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import search_icon from "../../../assests/images/search-icon.svg";

const ProcessedRequests = ({ tabValue }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useCustomNavigate();
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [pageNum, setPageNum] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    fetchShipments();
  }, [tabValue]);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const fetchShipments = async (p1 = 100, p2 = 0, customParams) => {
    setLoading(true);
    try {
      let queryParams;
      if (customParams) {
        queryParams = customParams;
      } else {
        queryParams = new URLSearchParams({
          page: (p2 + 1).toString(),
          limit: p1.toString(),
        });
      }

      const result = await API.Api(
        `${urls.PROCESSED_RTO_LIST}?${queryParams.toString()}`
      ).get();
      const response = result?.response?.data?.data;

      if (response) {
        setTotal(response?.metadata?.total || 0);
        setData(response?.rtoList || []);
        // Clear selections when data changes
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    } catch (error) {
      console.error("Error fetching RTO requests:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (record) => {
    navigate(`/rto-shipments-details/${record.awbNumber}`);
  };

  const handleRevoke = async (record) => {
    try {
      setLoading(true);
      await API.Api(urls.RTO_REQUEST_REVOKE).post({
        awbNumbers: [record.awbNumber],
      });
      message.success("RTO request revoked successfully");
      fetchShipments();
    } catch (error) {
      console.error("Error revoking RTO request:", error);
      message.error(
        error?.response?.data?.message || "Failed to revoke RTO request"
      );
    } finally {
      setLoading(false);
    }
  };

  // Bulk Actions
  const bulkRevokeRTO = async (awbNumbers) => {
    try {
      setLoading(true);
      const response = await API.Api(urls.RTO_REQUEST_REVOKE).post({
        awbNumbers: awbNumbers, // Changed from awbNumber to awbNumbers array
      });
      if (response.status) {
        message.success(`${awbNumbers.length} RTO requests revoked successfully`);
        fetchShipments();
        setSelectedRowKeys([]);
        setSelectedRows([]);
      } else {
        message.error(
          response?.response?.data?.message ||
            response?.response?.statusText ||
            "Failed to revoke RTO requests"
        );
      }
    } catch (error) {
      console.error("Error revoking RTO requests:", error);
      message.error(
        error?.response?.data?.message || "Failed to revoke RTO requests"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBulkRevoke = () => {
    // Only allow bulk revoke for approved requests
    const approvedRows = selectedRows.filter(row => row.requestStatus === "APPROVED");
    if (approvedRows.length === 0) {
      message.warning("Please select only approved requests to revoke");
      return;
    }
    
    const awbNumbers = approvedRows.map(row => row.awbNumber);
    Modal.confirm({
      title: "Confirm Bulk RTO Revoke",
      content: `Are you sure you want to revoke ${approvedRows.length} approved RTO requests?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => bulkRevokeRTO(awbNumbers),
      centered: true,
      maskClosable: true,
    });
  };

  // Row selection configuration
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (selected) {
        // Select all non-rejected rows only
        const selectableRows = data.filter(item => item.requestStatus !== "REJECTED");
        const selectableKeys = selectableRows.map(item => item.awbNumber);
        setSelectedRowKeys(selectableKeys);
        setSelectedRows(selectableRows);
      } else {
        // Deselect all rows
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const newSelectedRowKeys = selected 
        ? [...selectedRowKeys, record.awbNumber]
        : selectedRowKeys.filter(key => key !== record.awbNumber);
      
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.requestStatus === "REJECTED",
      name: record.awbNumber,
    }),
  };

  const columns = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
    },
    {
      title: (
        <>
          Request for RTO
          <br />
          Received On
        </>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },
    {
      title: (
        <>
          Request for RTO
          <br />
          Processed On
        </>
      ),
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "N/A",
    },
    {
      title: "Hub Name",
      dataIndex: "hubName",
      key: "hubName",
      render: (text) => text || "N/A",
    },
    {
      title: "Supervisor Name",
      dataIndex: "contactPersonName",
      key: "contactPersonName",
      render: (text) => text || "N/A",
    },
    {
      title: (
        <>
          Supervisor
          <br />
          Mobile no.
        </>
      ),
      dataIndex: "contactPersonPhone",
      key: "contactPersonPhone",
      render: (text) => text || "N/A",
    },
    {
      title: "RTO Request Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      render: (status) => {
        if (status === "APPROVED") {
          return (
            <div
              style={{
                color: "#00A651",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ marginRight: "5px", fontWeight: "bold" }}>✓</span>
              <span style={{ fontWeight: "bold" }}>Approved</span>
            </div>
          );
        } else if (status === "REJECTED") {
          return (
            <div
              style={{
                color: "#D02E2E",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{ marginRight: "5px", fontWeight: "bold" }}>✕</span>
              <span style={{ fontWeight: "bold" }}>Rejected</span>
            </div>
          );
        } else {
          return status;
        }
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title={"View Details"} placement="bottom">
            <p
              className="pointer"
              style={{ marginTop: "4px", marginBottom: "0" }}
              onClick={() => handleView(record)}
            >
              <View_icon />
            </p>
          </Tooltip>
          <Button
            type="primary"
            onClick={() => handleRevoke(record)}
            disabled={record.requestStatus !== "APPROVED"}
          >
            REVOKE
          </Button>
        </Space>
      ),
    },
  ];

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    const queryParams = new URLSearchParams({
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
    });
    fetchShipments(pagination.pageSize, pagination.current - 1, queryParams);
  };

  const onSearch = async (e) => {
    const searchQuery = e.target.value;
    if (searchQuery) {
      const queryParams = new URLSearchParams({
        awbNumber: searchQuery,
      });
      fetchShipments(100, 0, queryParams);
    } else {
      fetchShipments();
    }
  };

  return (
    <div className="rto-requests-list master-main-container m-1 p-1">
      <div className="p-1 rto-actions-header">
        <div className="bulk-actions">
          {selectedRowKeys.length > 0 ? (
            <div className="bulk-action-buttons">
              <span className="selected-count">
                {selectedRowKeys.length} item{selectedRowKeys.length > 1 ? 's' : ''} selected
              </span>
              <Button
                type="primary"
                danger
                onClick={handleBulkRevoke}
                disabled={loading || selectedRows.filter(row => row.requestStatus === "APPROVED").length === 0}
                className="bulk-revoke-btn"
              >
                Bulk Revoke ({selectedRows.filter(row => row.requestStatus === "APPROVED").length})
              </Button>
              {selectedRows.filter(row => row.requestStatus !== "APPROVED").length > 0 && (
                <span className="warning-text">
                  Only approved requests can be revoked
                </span>
              )}
            </div>
          ) : (
            <div className="bulk-info-message">
              <span className="info-text">
                💡 Select approved shipments using checkboxes to enable bulk revoke actions
              </span>
            </div>
          )}
        </div>
        <div className="search-section">
          <Input
            placeholder="Search by AWB Number"
            bordered
            style={{ borderRadius: "5px", height: "40px", width: "465px" }}
            suffix={<img src={search_icon} />}
            onChange={(e) => {
              onSearch(e);
            }}
          />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="awbNumber"
        rowSelection={rowSelection}
        pagination={{
          pageSize: pageSize,
          total: total,
          itemRender: itemRender,
          current: pageNum == 0 ? +1 : pageNum,
        }}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default ProcessedRequests;
